import React, { Component, Fragment } from 'react';
import { Row, Col, Input, Breadcrumb, notification } from 'antd/lib';

import { withApollo } from 'react-apollo';
import getIdExpedientePorFiltros from '../../../../graphql/querys/contravenciones/getIdExpedientePorFiltros.graphql';

import Loading from '../../../common/Loading';

class BuscarPorCodigo extends Component {
  state = {
    codigoBarras: [],
  };

  handleEnterCodigoBarras = e => {
    const codigoBarras = e.target.value.split(' ');
    console.log('PROPS: ', this.props);
    this.props.client
      .query({
        query: getIdExpedientePorFiltros,
        variables: {
          codigoOrganismo: codigoBarras[0],
          tipo: codigoBarras[1],
          numero: codigoBarras[2],
          anio: codigoBarras[3],
        },
        fetchPolicy: 'network-only',
      })
      .then(respuesta => {
        // console.log('LA RESPUESTA ES: ', respuesta);

        if (respuesta.data.getIdExpedientePorFiltros) {
          notification.success({
            message: 'Expediente Encontrado',
            description: 'Se ha encontrado el expediente correctamente',
          });
          let id = respuesta.data.getIdExpedientePorFiltros;
          this.props.history.push(`/contravenciones/expedientes/${id}`);
        }
      })
      .catch(err => {
        console.log('ERROR EN LA BUSQUEDA: ', err);

        notification.error({
          message: 'No se encontró el Expediente solicitado',
          description:
            'Disculpe, no se ha logrado encontrar el expediente solicitado',
        });
      });
  };
  render() {
    if (this.props.loadingExpediente) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Expedientes</Breadcrumb.Item>
          <Breadcrumb.Item>Buscar</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          <Fragment>
            <h2 style={{ textAlign: 'center' }}>
              {' '}
              Buscar Expediente Por Codigo de Barras{' '}
            </h2>
            <Row type={'flex'} justify={'center'}>
              <Col span={14}>
                <Input
                  // defaultValue={'JNQCI1 EXP 512494 2016'}
                  style={{ width: '70%', marginLeft: '15%' }}
                  placeholder="CodigoOrganismo Tipo Numero Año"
                  //onChange={this.handleOnChangeCodigoBarras}
                  onPressEnter={this.handleEnterCodigoBarras}
                />
              </Col>
            </Row>
          </Fragment>
        </div>
      </div>
    );
  }
}

export default withApollo(BuscarPorCodigo);
